import { render, staticRenderFns } from "./RevisarReservaView.vue?vue&type=template&id=3de31d8e&"
import script from "./RevisarReservaView.vue?vue&type=script&lang=ts&"
export * from "./RevisarReservaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports